import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SignUpBg from '../../../assets/image/signUpBg.png';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ApiHandler } from '../../../helper/ApiHandler';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../../components/Common/Loading';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const token = useSelector((state) => state.auth.token);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false); // Default loading state is false

    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            const response = await ApiHandler('/forgot_password.php', 'POST', { email }, token, dispatch, navigate);
            if (response.data.status.code === 1) {
                toast.success(response.data.status.message);
                navigate('/login');
                setEmail('');
                setLoading(false);
            } else {
                toast.error(response.data.status.message);
                setLoading(false);
            }
        } catch (error) {
            console.error('Forgot password error:', error);
            toast.error('Failed to send reset email. Please try again.');
            setLoading(false);
        }
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <div
            style={{
                backgroundImage: `url(${SignUpBg})`,
            }}
            className="min-h-screen bg-cover"
        >
            <div className="container mx-auto px-4 md:px-8">
                <div className="pt-16 md:pt-32">
                    <h1 className="flex font-bold justify-center items-center text-[#FFDD15] text-2xl md:text-4xl underline bg-cover">
                        FORGOT PASSWORD
                    </h1>
                </div>

                <div className="flex justify-center mt-8 md:mt-10 pb-10">
                    <form
                        onSubmit={handleSubmit}
                        className="bg-[#0E0E0E] p-4 md:p-6 rounded-xl w-full md:w-2/3 lg:w-1/2">
                        <div className="mb-4">
                            <label htmlFor="email" className="block text-white text-sm mb-2">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={email}
                                onChange={handleChange}
                                className="w-full p-2 rounded-md bg-[#222222] text-white border border-white/50"
                                required
                            />
                        </div>
                        <button type="submit" className="w-full mt-4 bg-yellow-500 text-black py-2 rounded-md font-semibold">
                            Send Reset Link
                        </button>
                        <div className="flex justify-center items-center mt-4 text-sm text-white">
                            <p>Remember your password?</p>
                            <Link to="/login" className="ml-2 text-yellow-500 hover:underline">
                                Sign In
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
